import React from 'react';

const GridTest = () => {
  return (
    <div className="min-h-screen bg-gray-900 p-fluid-base">
      <div className="container-fluid-xl mx-auto">
        <h1 className="heading-3xl text-white mb-fluid-xl text-center">
          Fluid Grid System Test
        </h1>

        {/* Basic 12-column grid */}
        <section className="mb-fluid-2xl">
          <h2 className="heading-xl text-cyan-400 mb-fluid-lg">12-Column Grid</h2>
          <div className="grid grid-cols-12 gap-fluid-base">
            {Array.from({ length: 12 }, (_, i) => (
              <div
                key={i}
                className="bg-cyan-500/20 border border-cyan-400/30 rounded p-fluid-sm text-center text-white"
              >
                Col {i + 1}
              </div>
            ))}
          </div>
        </section>

        {/* Responsive grid that stacks on mobile */}
        <section className="mb-fluid-2xl">
          <h2 className="heading-xl text-cyan-400 mb-fluid-lg">Responsive Grid (4 columns → 1 on mobile)</h2>
          <div className="grid grid-cols-4 gap-fluid-base">
            {Array.from({ length: 8 }, (_, i) => (
              <div
                key={i}
                className="bg-purple-500/20 border border-purple-400/30 rounded p-fluid-sm text-center text-white min-h-[100px] flex items-center justify-center"
              >
                Item {i + 1}
              </div>
            ))}
          </div>
        </section>

        {/* Auto-fit grid */}
        <section className="mb-fluid-2xl">
          <h2 className="heading-xl text-cyan-400 mb-fluid-lg">Auto-Fit Grid</h2>
          <div className="grid grid-cols-fluid-auto-fit gap-fluid-base">
            {Array.from({ length: 12 }, (_, i) => (
              <div
                key={i}
                className="bg-green-500/20 border border-green-400/30 rounded p-fluid-sm text-center text-white min-h-[100px] flex items-center justify-center"
              >
                Auto {i + 1}
              </div>
            ))}
          </div>
        </section>

        {/* Mixed spans */}
        <section className="mb-fluid-2xl">
          <h2 className="heading-xl text-cyan-400 mb-fluid-lg">Mixed Column Spans</h2>
          <div className="grid grid-cols-12 gap-fluid-base">
            <div className="col-span-8 bg-blue-500/20 border border-blue-400/30 rounded p-fluid-sm text-center text-white min-h-[100px] flex items-center justify-center">
              Span 8
            </div>
            <div className="col-span-4 bg-red-500/20 border border-red-400/30 rounded p-fluid-sm text-center text-white min-h-[100px] flex items-center justify-center">
              Span 4
            </div>
            <div className="col-span-6 bg-yellow-500/20 border border-yellow-400/30 rounded p-fluid-sm text-center text-white min-h-[100px] flex items-center justify-center">
              Span 6
            </div>
            <div className="col-span-6 bg-pink-500/20 border border-pink-400/30 rounded p-fluid-sm text-center text-white min-h-[100px] flex items-center justify-center">
              Span 6
            </div>
          </div>
        </section>

        {/* Different gap sizes */}
        <section className="mb-fluid-2xl">
          <h2 className="heading-xl text-cyan-400 mb-fluid-lg">Different Gap Sizes</h2>
          <div className="grid grid-cols-4 gap-fluid-xs mb-fluid-lg">
            {Array.from({ length: 4 }, (_, i) => (
              <div
                key={i}
                className="bg-indigo-500/20 border border-indigo-400/30 rounded p-fluid-sm text-center text-white min-h-[80px] flex items-center justify-center"
              >
                XS Gap
              </div>
            ))}
          </div>
          <div className="grid grid-cols-4 gap-fluid-lg">
            {Array.from({ length: 4 }, (_, i) => (
              <div
                key={i}
                className="bg-orange-500/20 border border-orange-400/30 rounded p-fluid-sm text-center text-white min-h-[80px] flex items-center justify-center"
              >
                LG Gap
              </div>
            ))}
          </div>
        </section>

        {/* Alignment examples */}
        <section className="mb-fluid-2xl">
          <h2 className="heading-xl text-cyan-400 mb-fluid-lg">Alignment Examples</h2>
          <div className="grid grid-cols-3 gap-fluid-base items-center justify-center min-h-[200px] bg-gray-800/50 rounded p-fluid-base mb-fluid-lg">
            <div className="bg-teal-500/20 border border-teal-400/30 rounded p-fluid-sm text-center text-white">
              Center
            </div>
            <div className="bg-teal-500/20 border border-teal-400/30 rounded p-fluid-sm text-center text-white">
              Aligned
            </div>
            <div className="bg-teal-500/20 border border-teal-400/30 rounded p-fluid-sm text-center text-white">
              Grid
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default GridTest;